import { toast } from "react-toastify";

type ToastOptions = {
    autoClose?: number;
    position?:
        | "top-right"
        | "top-center"
        | "top-left"
        | "bottom-right"
        | "bottom-center"
        | "bottom-left";
};

export function useToast() {
    return {
        success: (message: string, options?: ToastOptions) => {
            toast.success(message, options);
        },
        error: (message: string, options?: ToastOptions) => {
            toast.error(message, options);
        },
        info: (message: string, options?: ToastOptions) => {
            toast.info(message, options);
        },
        warning: (message: string, options?: ToastOptions) => {
            toast.warning(message, options);
        }
    };
}
